import {
  limparDocumento,
  validarCpfLocal,
  validarCnpjLocal,
} from '../../utility/documentoValidacao'

export const MASCARA_CPF_ORIGEM = '999.999.999-99'
export const MASCARA_CNPJ_ORIGEM = '99.999.999/9999-99'

export function somenteDigitosDocumentoOrigem(valor) {
  return limparDocumento(valor)
}

export function mascaraDocumentoOrigem(digitos) {
  return digitos.length > 11 ? MASCARA_CNPJ_ORIGEM : MASCARA_CPF_ORIGEM
}

/** Formata CPF (até 11 dígitos) ou CNPJ (12–14) enquanto o usuário digita. */
export function formatarDocumentoParcial(digitos) {
  const d = String(digitos ?? '').replace(/\D/g, '').slice(0, 14)
  if (!d) return ''

  if (d.length <= 11) {
    if (d.length <= 3) return d
    if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`
    if (d.length <= 9) {
      return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`
    }
    return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`
  }

  if (d.length <= 2) return d
  if (d.length <= 5) return `${d.slice(0, 2)}.${d.slice(2)}`
  if (d.length <= 8) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5)}`
  if (d.length <= 12) {
    return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8)}`
  }
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`
}

export function documentoOrigemCompleto(digitos) {
  return digitos.length === 11 || digitos.length === 14
}

export function documentoOrigemEhCnpj(digitos) {
  return digitos.length === 14
}

/** Enquanto digita ou com CPF completo (11 dígitos). */
export function documentoOrigemEhCpf(digitos) {
  return digitos.length > 0 && digitos.length <= 11
}

export function cpfOrigemCompleto(digitos) {
  return digitos.length === 11
}

/**
 * Valida CPF/CNPJ da origem (outra origem). Vazio é permitido.
 *
 * @returns {{ valido: boolean, mensagem?: string }}
 */
export function validarDocumentoOrigem(valor) {
  const digitos = somenteDigitosDocumentoOrigem(valor)
  if (!digitos) {
    return { valido: true }
  }

  if (digitos.length !== 11 && digitos.length !== 14) {
    return {
      valido: false,
      mensagem: 'Informe um CPF (11 dígitos) ou CNPJ (14 dígitos).',
    }
  }

  if (digitos.length === 11) {
    return validarCpfLocal(digitos)
      ? { valido: true }
      : { valido: false, mensagem: 'CPF inválido.' }
  }

  return validarCnpjLocal(digitos)
    ? { valido: true }
    : { valido: false, mensagem: 'CNPJ inválido.' }
}
